import { AccessDeniedTileInfo } from 'app/home/index.functions';
import AccessDeniedPopup from 'components/common/popup/AccessDeniedPopup';

export default function AccessDeniedPopupWrapper({ props }: { props: any }) {
    const setAccessDeniedPopupTile = (tile: AccessDeniedTileInfo | null) => {};

    const accessDeniedTile: AccessDeniedTileInfo = {
        element_id: 'string' === typeof props.element_id ? parseInt(props.element_id, 10) : props.element_id,
        segment_value_id: props.segment_value_id ?? 0,
    };

    return (
        <AccessDeniedPopup accessDeniedTile={accessDeniedTile} setAccessDeniedPopupTile={setAccessDeniedPopupTile} />
    );
}
